import { quSave } from '@/service/question'
import util from '@/tools/commonUtil'
// import iconSrc from '@/assets/images/edit/config/m-lef-slider@2x.png'
import iconSrc from '@/assets/images/edit/config/icon-npsbox.png'
export default {
  divStyle: ' border: 1px solid #D491A7;padding-right: 5px;border-radius: 5px; min-width: 91px;padding-left: 5px;',
  iconTit: 'NPS题',
  orderById: 80,
  elementType: 'NpsBox',
  elementDesc: 'NPS题',
  type: 'npsbox',
  category: 'paixuti',
  // 是否可配置
  config: true,
  title: 'NPS题',
  placeholder: 'NPS题',
  // 最小分
  paramInt01: 0,
  // 最大分
  paramInt02: 10,
  // 分数题 题目类型6：NPS题
  scoreQuType: '6',
  // 分数题  段位
  scoreQuParagraph: '11',
  itemKey: 'optionList',
  // 选项vo
  optionList: [],
  tmpValue: 0,
  value: null,
  ruleError: '该字段不能为空',
  toolbar: {
    config: false
  },
  saveUrl: '/survey/design/qu-score/ajaxSave',
  iconStyle: {
    background: 'url(' + iconSrc + ')',
    width: '19px',
    height: '16px',
    'background-size': 'contain',
    'background-repeat': 'no-repeat'
    // backgroundSize: '100% 100%'
  },
  saveFn () {
    return quSave({
      paramInt01: this.paramInt01,
      paramInt02: this.paramInt02,
      scoreQuType: this.scoreQuType,
      scoreQuParagraph: this.scoreQuParagraph,
      optionList: util.genList(this.optionList)
    }, this)
  },
  saveCb (data) {
    this.paramInt02 = data.paramInt02
    this.optionList = util.genRetList.call(this, data.optionList, 'option')
    this.scoreQuType = data.scoreQuType
    this.scoreQuParagraph = data.scoreQuParagraph
  },
  getAnswer () {
    const answer = []
    answer.push({
      belongId: this.belongId,
      belongAnswerId: this.belongAnswerId,
      quId: this.id,
      answserScore: this.value
    })
    return answer
  },
  getScoreQuParagraphList () {
    return RATE_CONFIG_MAPP[this.scoreQuType].scoreQuParagraphList
  },
  onScoreQuTypeChg (scoreQuType) {
    const {scoreQuParagraph, paramInt01, paramInt02} = RATE_CONFIG_MAPP[scoreQuType]
    this.scoreQuParagraph = scoreQuParagraph
    this.paramInt01 = paramInt01
    this.paramInt02 = paramInt02
    this.tmpValue = 0
    this.onScoreQuParagraphChg()
  },
  onScoreQuParagraphChg () {
    console.log('#### onScoreQuParagraphChg ####', this.scoreQuType)
    const rateConfig = RATE_CONFIG_MAPP[this.scoreQuType]
    const scoreQuParagraphList = rateConfig.scoreQuParagraphList
    const scoreQuParagraph = this.scoreQuParagraph
    if (scoreQuParagraphList) {
      this.paramInt02 = scoreQuParagraphList.filter(item => item.optionName === scoreQuParagraph)[0].paramInt02
    }
    const optionListMapp = rateConfig.optionListMapp[scoreQuParagraph]
    let optionList = []
    optionListMapp && optionListMapp.forEach(({optionTitle, optionName}, index) => {
      optionList.push({
        quId: '',
        optionTitle,
        optionName,
        orderById: index + 1 + '',
        visibility: '1'
      })
    })
    this.optionList.splice(0, this.optionList.length, ...optionList)
  }
}

const RATE_CONFIG_MAPP = {
  '6': {
    paramInt01: '0',
    paramInt02: '10',
    scoreQuParagraph: '11',
    scoreQuParagraphList: [
      {optionTitle: '11段', optionName: '11', paramInt02: '10'}
    ],
    optionList: [],
    optionListMapp: {
      '11': [
        {optionTitle: '完全不可能', optionName: '0'},
        {optionTitle: '极有可能', optionName: '11'}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/editor/NpsBox/config.js